module.exports = __webpack_public_path__ + "img/ring_g_s_1_null@3x.58040015.png";